import { Box, BoxProps, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';

export type OutstandingBalanceFormContentType = {
  outstandingBalance: string;
} & BoxProps;

export const OutstandingBalanceFormContent: React.VFC<OutstandingBalanceFormContentType> = ({ outstandingBalance, ...boxProps }) => {
  const l10n = useL10n();
  const { classes } = useStyles();

  if (!outstandingBalance) {
    return null;
  }

  return (
    <Box display="flex" alignItems="center" gap="64px" {...boxProps}>
      <Typography>{l10n.accountSettings.billing.outstandingBalance}</Typography>
      <Typography variant="h5" className={classes.balance}>
        ${outstandingBalance}
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  balance: {
    color: theme.palette.common.black,
  }
}));
